import React from 'react';
import { useTranslation } from 'react-i18next';
import { PRESS_MENTIONS } from '../config/press';

/**
 * PressBanner — bandă "as seen in" cu mențiunile de presă reale.
 *
 * Se afișează DOAR dacă există mențiuni în config/press.js — până atunci
 * randează null, ca să nu afirme nimic neverificabil. E prima dovadă socială
 * a paginii care poate fi verificată cu un click, de aceea fiecare nume e
 * link direct către articol.
 */
export default function PressBanner() {
  const { t } = useTranslation();

  if (!PRESS_MENTIONS.length) return null;

  return (
    <section style={{
      padding: 'clamp(16px, 2.5vw, 22px) clamp(16px, 5vw, 48px)',
      background: '#FFFFFF',
      borderBottom: '1px solid #F3F4F6',
    }}>
      <div style={{
        maxWidth: '1180px', margin: '0 auto',
        display: 'flex', flexWrap: 'wrap', gap: 'clamp(12px, 2vw, 28px)',
        justifyContent: 'center', alignItems: 'center',
      }}>
        <span style={{ fontSize: 11, fontWeight: 600, color: '#6B7280', textTransform: 'uppercase', letterSpacing: 2, fontFamily: 'DM Mono, monospace' }}>
          {t('landing.press_banner.label')}
        </span>
        {PRESS_MENTIONS.map((m) => (
          <a
            key={m.url}
            href={m.url}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              fontFamily: 'Playfair Display, serif', fontSize: 17, fontWeight: 700,
              color: '#0A1428', textDecoration: 'none', borderBottom: '2px solid #D4AF37',
              paddingBottom: 2,
            }}
          >
            {m.name}
          </a>
        ))}
      </div>
    </section>
  );
}
